var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('MobileDrawer', {
    attrs: {
      "toggler": _vm.toggler
    },
    on: {
      "click": function click($event) {
        _vm.toggler = !_vm.toggler;
      }
    }
  }), _c('div', {
    staticClass: "admin-header"
  }, [_c('div', [_c('b-navbar-brand', {
    staticClass: "attach-media",
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Route-line",
      "src": require("@/assets/logo.png")
    }
  })]), _c('button', {
    staticClass: "hamberger",
    on: {
      "click": function click($event) {
        _vm.toggler = !_vm.toggler;
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })])], 1), _c('div', {
    staticClass: "d-flex"
  })])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }